import { getSalonAdminApiBaseUrl } from '../../salon-admin/utils/apiConfig';
import { fetchWithTimeout } from '../../salon/utils/fetchWithTimeout';
import { buildHqSessionHeaders } from '../../admin-shared/hqSessionAuth';
import { PORTAL_ID } from './api';

function adminBase() {
  return (getSalonAdminApiBaseUrl() || '').replace(/\/$/, '');
}

async function faceidPartnerPost(path, body, timeoutMs = 30000) {
  const base = adminBase();
  if (!base) {
    throw new Error('Salon admin API is not configured');
  }
  const headers = buildHqSessionHeaders(PORTAL_ID, { 'Content-Type': 'application/json' });
  const res = await fetchWithTimeout(`${base}${path}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body || {}),
    timeoutMs,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || data?.message || 'FaceID CRM request failed');
  }
  return data;
}

/** InnoSmarti FaceID lookup (customerDetails + select). */
export async function lookupFaceidCustomerByMobile(mobile) {
  return faceidPartnerPost('/checkin-queue/faceid-customer-lookup', {
    mobile_number: String(mobile || '').trim(),
  });
}

/** Create/update customer at InnoSmarti via /store (salon_id + org_id from partner JWT). */
export async function storeFaceidCustomer(profile) {
  return faceidPartnerPost('/checkin-queue/faceid-customer-store', { profile }, 45000);
}

/** Push vendor update event when webhook URL is configured on the server. */
export async function syncFaceidCustomerUpdate(profile, changedFields) {
  const body = { profile };
  if (Array.isArray(changedFields) && changedFields.length) {
    body.changed_fields = changedFields;
  }
  return faceidPartnerPost('/checkin-queue/faceid-customer-update', body, 45000);
}
